var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSendEmail2 = function SvgSendEmail2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M1.12 2.405a.944.944 0 0 1 1.242-1.308l11.968 6.08a.472.472 0 0 1 0 .842L2.362 14.106A.944.944 0 0 1 1.12 12.8l3.184-5.202L1.12 2.405Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.588 7.597H4.301",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgSendEmail2 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNiAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xLjExOTk5IDIuNDA0NzVDMC45MTgyODkgMi4wNDM4NCAwLjk3NDg3NyAxLjU5MzY4IDEuMjU5NjMgMS4yOTM5MkMxLjU0NDM4IDAuOTk0MTU3IDEuOTkxMDUgMC45MTQ1NCAyLjM2MTgzIDEuMDk3NDVMMTQuMzI5NiA3LjE3N0MxNC40ODc5IDcuMjU3NTMgMTQuNTg3NiA3LjQyMDEzIDE0LjU4NzYgNy41OTc3NkMxNC41ODc2IDcuNzc1NCAxNC40ODc5IDcuOTM4IDE0LjMyOTYgOC4wMTg1M0wyLjM2MTgzIDE0LjEwNjNDMS45OTEwNSAxNC4yODkyIDEuNTQ0MzggMTQuMjA5NiAxLjI1OTYzIDEzLjkwOThDMC45NzQ4NzcgMTMuNjEgMC45MTgyODkgMTMuMTU5OSAxLjExOTk5IDEyLjc5OUw0LjMwMzU5IDcuNTk3NDVMMS4xMTk5OSAyLjQwNDc1WiIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE0LjU4OCA3LjU5NzQySDQuMzAwNzgiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";